import {
	RxSelectBoxItemObject,
	RxSelectBoxItemObjectInitialize,
} from "../components/RxSelectBox/RxSelectBox";

export const isNullOrUndefined = (val: any): boolean => {
	return val === null || val === undefined;
};

export const isNullOrUndefinedOrEmpty = (val: string): boolean => {
	return val === null || val === undefined || val.trim() === "";
};

export const getRxSelectBoxItemObjectForUserValue = (
	options: RxSelectBoxItemObject[],
	value: string | null | undefined
): RxSelectBoxItemObject => {
	return value !== null && value !== undefined
		? options.filter((x) => x.value.toString() === value.toString())[0]
		: RxSelectBoxItemObjectInitialize;
};
